
//TODO: Eliminar fake data

const unidades = [
    // {
    //     key: "numeroSolicitud",
    //     label: "Nro. Solicitud",
    //     sortable: true,
    // },
    {
        key: "fechaSolicitud",
        label: "Fecha de solicitud",
        sortable: true,
    },
    {
        key: "marca",
        label: "Marca",
        sortable: true,
    },
    {
        key: "modelo",
        label: "Modelo",
        sortable: true,
    },
    {
        key: "cantidad",
        label: "Cantidad de vehículos",
        sortable: true,
    }

];
const siniestros = [
    {
        siniestro: 1234,
        fecIngreso: "2019-07-14",
        fecAccidente: "2019-07-13",
        idConductor: 11,
        nombreConductor: "Juan Perez",
        patente: "KLA-111",
        gravedad: "Leve"
    },
    {
        siniestro: 1111,
        fecIngreso: "2020-08-14",
        fecAccidente: "2020-08-13",
        idConductor: 12,
        nombreConductor: "Carlos Lopez",
        patente: "ABC-123",
        gravedad: "Leve"
    },
    {
        siniestro: 2222,
        fecIngreso: "2020-10-14",
        fecAccidente: "2020-10-10",
        idConductor: 10,
        nombreConductor: "Julio Caceres",
        patente: "KOB-548",
        gravedad: "Leve"
    },
    {
        siniestro: 3333,
        fecIngreso: "2021-01-03",
        fecAccidente: "2021-01-02",
        idConductor: 14,
        nombreConductor: "Jorge Gomez",
        patente: "MFX-734",
        gravedad: "Moderado"
    }
];

module.exports = {
    unidades,
    siniestros
};
